import { IconTypes } from 'components/basic/Icon';

export const footerItems = [
  {
    header: 'Resources',
    items: [
      {
        href: 'mailto:support@welltory.com',
        text: 'Contact Us',
      },
      {
        href: 'https://help.welltory.com/',
        text: 'Support',
      },
      {
        href: 'https://welltory.com/terms/',
        text: 'Terms of Use',
      },
      {
        href: 'https://welltory.com/privacy/',
        text: 'Privacy Policy',
      },
      {
        href: 'https://welltory.com/cookie/',
        text: 'Cookie Policy',
      },
    ],
  },
  {
    header: 'Company',
    items: [
      {
        href: 'https://welltory.com/team/',
        text: 'Team',
      },
      {
        href: 'https://welltory.com/our-story/',
        text: 'Our Story',
      },
      {
        href: 'https://welltory.com/press-kit/',
        text: 'Press Kit',
      },
      {
        href: 'https://welltory.com/testimonials/',
        text: 'Testimonials',
      },
      {
        href: 'https://welltory.com/plans/',
        text: 'Plans',
      },
    ],
  },
  {
    header: 'Developers',
    items: [
      {
        href: 'https://help.welltory.com/articles/3748589',
        text: 'Integration',
      },
      {
        href: 'https://welltory.com/for-research/',
        text: 'For Research',
      },
      {
        href: 'https://github.com/Welltory',
        text: 'Open Source',
      },
      {
        href: 'https://github.com/Welltory/hrv-covid19',
        text: 'Covid-19 Research',
      },
      {
        href: 'https://welltory.com/devices/',
        text: 'Devices',
      },
      {
        href: 'mailto:security@welltory.com',
        text: 'Report Security Vulnerabilities',
      },
    ],
  },
];

export const appsItems: {
  text: string;
  icon: IconTypes;
  href: string;
  analyticsButtonId: string;
}[] = [
  {
    text: 'App Store',
    icon: IconTypes.apple,
    href: 'https://welltory.onelink.me/yCOv?af_js_web=true&af_ss_ver=2&pid=welltory.com',
    analyticsButtonId: 'appstore',
  },
  {
    text: 'Google Play',
    icon: IconTypes.googlePlay,
    href: 'https://welltory.onelink.me/FLHY?af_js_web=true&af_ss_ver=2&pid=welltory.com',
    analyticsButtonId: 'googleplay',
  },
  {
    text: 'Huawei AppGallery',
    icon: IconTypes.huaweiAppGallery,
    href: 'https://appgallery.huawei.com/#/app/C101339555',
    analyticsButtonId: 'HuaweiAppGallery',
  },
  {
    text: 'Galaxy Store',
    icon: IconTypes.galaxyStore,
    href: 'https://galaxystore.samsung.com/detail/com.welltory.client.android',
    analyticsButtonId: 'GalaxyStore',
  },
];

export const socialItems: {
  text: string;
  icon: IconTypes;
  href: string;
  analyticsButtonId: string;
}[] = [
  {
    text: 'Twitter',
    icon: IconTypes.twitter,
    href: 'https://twitter.com/welltory/',
    analyticsButtonId: 'twitter',
  },
  {
    text: 'Facebook',
    icon: IconTypes.facebook,
    href: 'https://www.facebook.com/welltory/',
    analyticsButtonId: 'facebook',
  },
  {
    text: 'Instagram',
    icon: IconTypes.instagram,
    href: 'https://www.instagram.com/welltory/',
    analyticsButtonId: 'Instagram',
  },
  {
    text: 'LinkedIn',
    icon: IconTypes.linkedin,
    href: 'https://www.linkedin.com/company/welltory/',
    analyticsButtonId: 'linkedin',
  },
  {
    text: 'Apple Music',
    icon: IconTypes.appleMusic,
    href: 'https://music.apple.com/us/album/ambient-space-travels/1629680723?l=en',
    analyticsButtonId: 'appleMusic',
  },
  {
    text: 'Spotify',
    icon: IconTypes.spotify,
    href: 'https://open.spotify.com/album/1HbzsPGItI0FJzU7sNvRng?si=mBuJUFp_RWSR_Mloil0ReA',
    analyticsButtonId: 'spotify',
  },
];
